import React from 'react';

import propTypes from 'propTypes';
import classNames from 'classnames';

export default class Sidebar extends React.Component {
  static propTypes = {
    isLarge: propTypes.bool.isRequired,
    label: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
    isShowingBorder: propTypes.bool.isRequired,
    value: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
    extraClasses: propTypes.oneOfType([propTypes.string, propTypes.object]),
  };

  static defaultProps = {
    isLarge: false,
    isShowingBorder: true,
    color: null,
  };

  render() {
    const {
      label,
      value,
      isLarge,
      isShowingBorder,
      color,
      extraClasses,
    } = this.props;
    const className = classNames(
      'CartSidebar__order-summary__row',
      color,
      extraClasses,
      {
        'CartSidebar__order-summary__row--large': isLarge,
        'CartSidebar__order-summary__row--bordered': isShowingBorder,
      }
    );
    return (
      <div className={className}>
        <div className="CartSidebar__order-summary__row__label">{label}</div>
        <div className="CartSidebar__order-summary__row__value">{value}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/sidebar/OrderSummaryRow.js